export function compareTableNumbers(a, b) {
    return String(a ?? '').localeCompare(String(b ?? ''), 'ro', { numeric: true, sensitivity: 'base' });
}

export function sortTablesByNumber(tables, { groupByZone = false } = {}) {
    return [...(tables || [])].sort((a, b) => {
        if (groupByZone) {
            const zoneCmp = String(a.zone || '').localeCompare(String(b.zone || ''), 'ro', { sensitivity: 'base' });
            if (zoneCmp !== 0) return zoneCmp;
        }
        return compareTableNumbers(a.number, b.number);
    });
}
